import {Observable} from "rxjs";
import {PromotionDetail} from "../dtos/promotion-detail";
import {PromotionList} from "../dtos/promotion-list";

export abstract class PromotionRemote {
    public abstract getPromotionList(itemsPerPage: number, page: number): Observable<PromotionList>;
    public abstract getPromotionDetail(promotionCode: string): Observable<PromotionDetail>;
}
